// extracted by mini-css-extract-plugin
export default {"root":"trade-bar-field-with-label_root__ZFphm","label":"trade-bar-field-with-label_label__0EVMW"};